/**
 * Read-only profile vs role-specific edit forms.
 * View / search / notifications should use profile paths, not edit screens.
 */

export function userProfilePath(userId) {
  if (userId == null || userId === "") return null;
  return `/users/${userId}`;
}

/** Area prefix for the signed-in viewer's active role. */
export function roleAreaPrefix(viewerRole = null) {
  const viewer = String(viewerRole || "ADMIN").toUpperCase();
  if (viewer === "MANAGER") return "/manager";
  if (viewer === "COACH") return "/coach";
  return "/admin";
}

/** List route for entity type based on viewer role. */
export function userListPath(entityRole, viewerRole = null) {
  const entity = String(entityRole || "").toUpperCase();
  const viewer = String(viewerRole || "ADMIN").toUpperCase();
  if (viewer === "MANAGER") {
    if (entity === "STUDENT") return "/manager/students";
    if (entity === "COACH") return "/manager/coaches";
    return null;
  }
  if (viewer === "COACH") {
    if (entity === "STUDENT") return "/coach/students";
    return null;
  }
  if (entity === "STUDENT") return "/admin/students";
  if (entity === "COACH") return "/admin/coaches";
  if (entity === "MANAGER") return "/admin/managers";
  return null;
}

/** Edit route for a user based on their roles and the viewer's active role. */
export function userEditPath(userId, roles = [], viewerRole = null) {
  if (userId == null || userId === "") return null;
  const normalized = (Array.isArray(roles) ? roles : [roles])
    .filter(Boolean)
    .map((r) => String(r).toUpperCase());
  const viewer = String(viewerRole || "ADMIN").toUpperCase();
  const prefix = roleAreaPrefix(viewer);

  if (viewer === "MANAGER") {
    if (normalized.includes("STUDENT")) return `${prefix}/students/${userId}`;
    return null;
  }
  if (viewer === "COACH") {
    return null;
  }

  if (normalized.includes("STUDENT")) return `${prefix}/students/${userId}`;
  if (normalized.includes("COACH")) return `${prefix}/coaches/${userId}`;
  if (normalized.includes("MANAGER")) return `${prefix}/managers/${userId}`;
  return `${prefix}/users/${userId}`;
}

/**
 * Rewrites legacy "view" links that pointed at edit forms.
 * e.g. /admin/students/5 → /users/5
 */
export function normalizeUserViewLink(link) {
  if (!link || typeof link !== "string") return link;
  const m = link.match(/^\/(?:admin|manager|coach|student)\/(students|coaches|managers)\/(\d+)$/);
  if (m) return `/users/${m[2]}`;
  return link;
}
